var PhxCheckout = (function (PhxCheckout) {
    PhxCheckout.util = function () {
        function _getWindow() {
            return window;
        }
        return {
            getWindow: _getWindow
        };
    }();

    return PhxCheckout;
    
}(PhxCheckout || {}));
